import {Component, OnInit, Input} from '@angular/core';
import {ControlContainer, FormBuilder} from '@angular/forms';

import {MessageService, DocumentService, ProcedureService, MasterService} from "@services";
import {zip} from "rxjs";

@Component({
  selector: 'app-document-user',
  templateUrl: './document-user.component.html',
  styleUrls: ['./document-user.component.scss'],
})
export class DocumentUserComponent implements OnInit {
  public documentForm;
  documentSupports: any[] = [];
  @Input() tramiteObject: any;
  @Input() title!: string;
  @Input() stateInput: boolean = false;
  @Input() isLegalPerson: boolean = false;

  urlImageView: string =
    'https://cdn-icons-png.flaticon.com/512/2889/2889358.png';
  urlDowmloadpdf: string =
    'https://cdn-icons-png.flaticon.com/512/337/337946.png';

  datalocalURL: string;

  public programTypes: any[] = [];
  public titleTypes: any[] = [];
  public typeProfessional: any[] = [];

  constructor(
    public fb: FormBuilder,
    private procedureService: ProcedureService,
    private controlContainer: ControlContainer,
    private popUpService: MessageService,
    private documentService: DocumentService,
    private masterService: MasterService
  ) {
  }

  ngOnInit(): void {
    this.documentForm = this.controlContainer.control;
    this.documentForm = this.documentForm.controls['documentForm'];
    this.documentSupports = this.tramiteObject.documentSuppors;
    this.getListsSelects();
  }

  visorPdf(pathDocument) {
    //Descargar archivo
    try {
      this.popUpService.infoAlert(
        'Cargando documento...',
        4000);
      let fileObtenido = null;
      // tslint:disable-next-line: no-unused-variable
      this.documentService.getViewPdfByPath(pathDocument).subscribe((resp) => {
        fileObtenido = resp.content;
        const byteArray = new Uint8Array(atob(fileObtenido).split('').map((char) => char.charCodeAt(0)));
        const file = new Blob([byteArray], {type: 'application/pdf'});
        this.datalocalURL = window.URL.createObjectURL(file);
        document.querySelector("iframe").src = this.datalocalURL;
      }, error => {
        this.popUpService.errorAlert(
          'Ocurrió un error al cargar el documento.',
          4000);
      })
    } catch (e) {
      this.popUpService.errorAlert(
        'Ocurrió un error al previsualizar el documento.',
        4000);
    }

  }

  downloadPdf(pathDocument, nameDocument: string) {

    try {
      this.popUpService.infoAlert(
        'Cargando documento...',
        4000);
      //Descargar archivo
      let fileObtenido = null;
      // tslint:disable-next-line: no-unused-variable
      this.documentService.getViewPdfByPath(pathDocument).subscribe((resp) => {
        console.log("valor documento", resp)
        fileObtenido = resp.content;
        console.log("este es el fileObtenido", fileObtenido)
        const byteArray = new Uint8Array(atob(fileObtenido).split('').map((char) => char.charCodeAt(0)));
        console.log("este es el fileObtenido", byteArray)
        const file = new Blob([byteArray], {type: 'application/pdf'});
        this.datalocalURL = URL.createObjectURL(file);
        window.open(this.datalocalURL, '_blank');
      }, error => {
        this.popUpService.errorAlert(
          'Ocurrió un error al cargar el documento.',
          4000);
      })
    } catch (e) {
      this.popUpService.errorAlert(
        'Ocurrió un error al descargar el documento.',
        4000);
    }

  }

  /**
   * Carga las listas de los desplegables
   */
  private getListsSelects(): void {
    zip(
      this.masterService.getProgramTypes(),
      this.masterService.getTitleTypes(),
      this.masterService.getTypeProfessional()
    ).subscribe(resp => {
      this.programTypes = resp[0];
      this.titleTypes = resp[1];
      this.typeProfessional = resp[2];
    })
  }
}
